import React, { useEffect, useMemo, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import {
  getRootClassNames,
  SwanProvider,
  SiteContent,
  SiteMain,
  MainContentStart,
  ScreenClassProvider,
  SwanHead,
  SWAN_BASE_URL_MAP,
  SWAN_STYLE_KEY_MAP,
  Spinner,
  useBrowserClasses,
  Box
} from "@vp/swan";

import { NotificationProvider } from "./NotificationContext";
import AuthenticationScreensLayout from "./Authentication/ScreensLayout";
import { useSiteConfigPersistor } from "./SiteConfig/useSiteConfigPersistor";
import { AuthenticationInfoProvider } from "./Authentication/AuthenticationContext";
import {
  VpSignAuth0Context,
  Auth0DefaultConfig,
  SignAuth0Provider
} from "./Auth0Context";

const styleSheetKeys = [
  SWAN_STYLE_KEY_MAP.core,
  SWAN_STYLE_KEY_MAP.grid,
  SWAN_STYLE_KEY_MAP.button,
  SWAN_STYLE_KEY_MAP.alertBox,
  SWAN_STYLE_KEY_MAP.hidden,
  SWAN_STYLE_KEY_MAP.spinner,
  SWAN_STYLE_KEY_MAP.icon
];

const App = () => {
  const auth0Context = useMemo(
    () => new VpSignAuth0Context(Auth0DefaultConfig),
    []
  );
  const browser = useBrowserClasses();
  const rootClassName = getRootClassNames();
  const [loadMainPage, setLoadMainPage] = useState(false);

  const onPageLoad = () => {
    setLoadMainPage(true);
  };
  useEffect(() => {
    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
      return () => { window.removeEventListener("load", onPageLoad); };
    }
  }, []);

  useSiteConfigPersistor();

  const loader = () => {
    return (
      <Box textAlign="center">
        <Spinner showText={true} size="super" accessibleText="Loading..." />
      </Box>
    );
  };

  return (
    <HelmetProvider>
    <SwanProvider swanBaseUrl={SWAN_BASE_URL_MAP.default.cdn}>
      <Helmet
        htmlAttributes={{ class: browser }}
        bodyAttributes={{ class: rootClassName }}
      />
    <SwanHead
      styleSheetKeys={styleSheetKeys}
      renderWith={Helmet}
      renderStyleContentAsChildren
    />
      <SiteContent>
        <SiteMain>
          <MainContentStart />
          <NotificationProvider>
            <AuthenticationInfoProvider>
              <SignAuth0Provider value={auth0Context}>
                <ScreenClassProvider>
                { loadMainPage ? <AuthenticationScreensLayout /> : loader() }
                </ScreenClassProvider>
              </SignAuth0Provider>
            </AuthenticationInfoProvider>
          </NotificationProvider>
        </SiteMain>
      </SiteContent>
    </SwanProvider>
    </HelmetProvider>
  );
};

export default App;
